class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.querySelector('#cart-notification');
    this.header = document.querySelector('sticky-header');
    this.links = document.querySelector('.po-cart-notification__links');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.domBody = document.querySelector('body');

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.domBody.classList.add('tw-overflow-y-hidden');
    this.notification.classList.add('active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );
  }


  close() {
    this.domBody.classList.remove('tw-overflow-y-hidden');
    this.notification.classList.remove('active');
    removeTrapFocus(this.notification);
  }

  updateAccessorySpacing(){
    if(this.links.classList.contains('po-cart-notification__links-fixed')) return;
    
    this.links.classList.add('po-cart-notification__links-fixed');
    const accessories = document.querySelector('.po-minicart-accessories-container');
    const linksHeight = this.links.clientHeight;
    accessories.style.marginBottom = linksHeight + 'px';
  }

  resolveCartItemKey(parsedState) {
    if (parsedState?.key) return parsedState.key;

    const items = parsedState?.items;
    if (!Array.isArray(items) || items.length === 0) return null;

    return items[items.length - 1]?.key || items[0]?.key || null;
  }

  findNotificationLineItem(doc, cartItemKey) {
    if (!doc || !cartItemKey) return null;

    const itemId = `cart-notification-product-${cartItemKey}`;
    let lineItem = doc.getElementById(itemId);

    if (!lineItem) {
      lineItem = doc.querySelector(`[id="${CSS.escape(itemId)}"]`);
    }

    if (!lineItem) {
      const nodes = doc.querySelectorAll('[id^="cart-notification-product-"]');
      lineItem = nodes.length ? nodes[nodes.length - 1] : null;
    }

    return lineItem;
  }

  renderContents(parsedState) {
    this.cartItemKey = this.resolveCartItemKey(parsedState);

    this.getSectionsToRender().forEach((section) => {
      const sectionHtml = parsedState?.sections?.[section.id];
      const container = document.getElementById(section.id);

      if (!container) return;

      if (!sectionHtml) {
        console.warn('[CartNotification] Missing section HTML:', section.id);
        return;
      }

      if (section.id === 'po-cart-notification-product') {
        const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
        const newItem = this.findNotificationLineItem(doc, this.cartItemKey);

        if (!newItem) {
          const sectionRoot = doc.querySelector('.shopify-section') || doc.body;
          if (sectionRoot?.innerHTML?.trim()) {
            container.innerHTML = sectionRoot.innerHTML;
          }
          return;
        }

        const newVariantId = newItem.getAttribute('data-variant-id');
        const existingItem = newVariantId
          ? container.querySelector(`[data-variant-id="${newVariantId}"]`)
          : null;

        if (existingItem) existingItem.remove();

        const accessoriesSlide = newVariantId
          ? document.querySelector(`.swiper-slide[data-variant-id="${newVariantId}"]`)
          : null;

        if (accessoriesSlide) {
          const swiperInstance = accessoriesSlide.closest('.swiper')?.swiper;
          accessoriesSlide.remove();
          if (swiperInstance) swiperInstance.update();
        }

        container.appendChild(document.importNode(newItem, true));

        if (parsedState.product_type === 'Accessories') {
          if (window.matchMedia('(max-width: 768px)').matches) {
            this.updateAccessorySpacing();
          }

          window.dispatchEvent(new CustomEvent('minicart:updated', {}));
        }

        return;
      }

      if (section.selector) {
        const inner = this.getSectionInnerHTML(sectionHtml, section.selector);
        if (inner != null) container.innerHTML = inner;
      } else {
        container.innerHTML = this.getSectionInnerHTML(sectionHtml, '.shopify-section');
      }
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'po-cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
